const PIGGY_BANK_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/a8eacb8c-b3cc-43a8-889a-2f5bf5f0c36a/images/c91e2b8de9fd95a5c54be1908234cf4b62ed417aee0539dcecc79e64dca55f13.jpeg";

export const SquaresArt = ({ compact = false }) => {
  const rotation = compact ? "" : "rotate-[-2deg]";

  return (
    <figure
      data-testid="squares-art"
      className={`overflow-hidden rounded-3xl border-2 border-amber-200 bg-[#edf8f0] shadow-[0_18px_40px_-20px_rgba(4,120,87,0.35)] transition-transform duration-300 hover:rotate-0 ${rotation}`}
    >
      <img
        data-testid="cofreweb-piggy-bank-image"
        src={PIGGY_BANK_IMAGE}
        alt="Cofrinho verde da CofreWeb recebendo uma moeda"
        className="aspect-square w-full object-cover"
      />
    </figure>
  );
};
